import React from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";
import { Route, Switch } from "react-router";
import { ConnectedRouter } from "connected-react-router";

import "./i18n/index";
import store, { history } from "./store";
import Layout from "./containers/Layout";
import Editor from "./loadables/Editor";
import ModelExport from "./containers/ModelExport";
import Collections from "./containers/Collections";
import CollectionsList from "./containers/CollectionsList";
import PatternsList from "./containers/PatternsList";
import Realisations from "./containers/Realisations";
import RealisationMcDonalds from "./containers/RealisationMcDonalds";
import RealisationEurojustLaHaye from "./containers/RealisationEurojustLaHaye";
import RealisationAffairesEtrangeres from "./containers/RealisationAffairesEtrangeres";
import RealisationInstitutionInternationale from "./containers/RealisationInstitutionInternationale";
import RealisationMgmCasino from "./containers/RealisationMgmCasino";
import About from "./containers/About";
import Support from "./containers/Support";
import SupportBusiness from "./containers/SupportBusiness";
import SupportAcoustic from "./containers/SupportAcoustic";
import SupportTechnical from "./containers/SupportTechnical";
import Contact from "./containers/Contact";
import Terms from "./containers/Terms";
import AccountIndex from "./containers/AccountIndex";
import Home from "./containers/Home";
import NotFound from "./components/NotFound";
import Maintenance from "./components/Maintenance";
import Admin from "./components/Admin";

import "./stylesheets/index.css";

const mountNode = document.getElementById("root");

if (process.env.REACT_APP_MAINTENANCE_MODE) {
  render(<Maintenance />, mountNode);
} else {
  render(
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <Layout>
          <Switch>
            {/* admin */}
            <Route path="/admin" component={Admin} />

            {/* models apercu pdf*/}
            <Route
              path="/:lang(en|es)?/models/export/:id"
              component={ModelExport}
            />
            <Route path="/:lang(en|es)?/models/:id/edit" component={Editor} />
            <Route path="/:lang(en|es)?/create" component={Editor} />

            {/* account */}
            <Route path="/:lang(en|es)?/account" component={AccountIndex} />

            {/* collections */}
            <Route
              path="/:lang(en|es)?/collections/patterns"
              component={PatternsList}
            />
            <Route
              path="/:lang(en|es)?/collections/surfaces"
              component={CollectionsList}
            />
            <Route path="/:lang(en|es)?/collections" component={Collections} />

            {/* realisations */}
            <Route
              path="/:lang(en|es)?/realisations/mcdonalds-champs-elysees"
              component={RealisationMcDonalds}
            />
            <Route
              path="/:lang(en|es)?/realisations/eurojust-la-haye"
              component={RealisationEurojustLaHaye}
            />
            <Route
              path="/:lang(en|es)?/realisations/ministere-des-affaires-etrangeres"
              component={RealisationAffairesEtrangeres}
            />
            <Route
              path="/:lang(en|es)?/realisations/institution-internationale"
              component={RealisationInstitutionInternationale}
            />
            <Route
              path="/:lang(en|es)?/realisations/mgm-casino"
              component={RealisationMgmCasino}
            />
            <Route
              path="/:lang(en|es)?/realisations"
              exact
              component={Realisations}
            />
            {/* support */}
            <Route
              path="/:lang(en|es)?/support/business"
              component={SupportBusiness}
            />
            <Route
              path="/:lang(en|es)?/support/technical"
              component={SupportTechnical}
            />
            <Route
              path="/:lang(en|es)?/support/acoustic"
              component={SupportAcoustic}
            />
            <Route path="/:lang(en|es)?/support" exact component={Support} />

            {/* others */}
            <Route path="/:lang(en|es)?/terms" component={Terms} />
            <Route path="/:lang(en|es)?/contact" component={Contact} />
            <Route path="/:lang(en|es)?/about" component={About} />
            <Route path="/:locale(en|es)?" component={Home} />

            {/* not found */}
            <Route component={NotFound} />
          </Switch>
        </Layout>
      </ConnectedRouter>
    </Provider>,
    mountNode
  );
}



// WEBPACK FOOTER //
// ./src/index.js